import { Component, OnInit, Input } from '@angular/core'
import { NetworkStateGateway } from '../../gateways/network-state-gateway'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { ActivatedRoute, Router, Params } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'

import { UserAccessGateway } from '../../gateways/user-access-gateway'

@Component({
    selector: 'stateList',
    templateUrl: 'stateList.component.html',
    styleUrls: ['stateList.component.scss']
})
export class StateListComponent implements OnInit {
    states: ValidatedSelectOptionModel[]
    @Input() DrugPricingToolUrl
    selectedState: string
    zipCode: number
    hasError: boolean
    ErrorMessages: any[]
    notBlankValidator: NotBlankGenericFieldValidator
    Selectedplanyear: number
    IcName: string
    LOGO: string
    regioncode: number

    constructor(private _networkUserAccessGateway: UserAccessGateway, private _networkStateGateway: NetworkStateGateway, private route: ActivatedRoute, private router: Router) {

        this.setThemeOnPlanYearChange()
    }

    ngOnInit() {

        //Load Adobe launch script
        this._networkUserAccessGateway.LoadAdobeScript()

        this.route.params.subscribe(params => {
            if (params) {
                this.DrugPricingToolUrl = params['toolUrl'];
            }
        });

        //this._networkStateGateway.getAllStateRegions().subscribe(
        this._networkStateGateway.getAllStatesforMailing().subscribe(
            (model: ValidatedSelectOptionModel[]) => {
                this.states = model

                this.states.unshift({ value: 0, text: '-- Choose One --', })
            }
        )

    }
    setThemeOnPlanYearChange() {

        console.log("state list plan year: " + Number(sessionStorage.getItem("PLANYEAR")))
        this.Selectedplanyear = Number(sessionStorage.getItem("PLANYEAR"))


        if (Number(this.Selectedplanyear) === 2020) {
            this.IcName = 'ssi'
            this.LOGO = "assets/images/SSDrugPricing.png"
        }
        else if (Number(this.Selectedplanyear) === 2021) {
            this.IcName = 'aetna'
            this.LOGO = "assets/images/DrugPricing.png"
        }
        else {
            this.IcName = 'aetna'
            this.LOGO = "assets/images/DrugPricing.png"
        }

    }

    navigateToDrugPricingTool() {
        this.ErrorMessages = []
        this.hasError = false

        if (this.selectedState === undefined || this.selectedState === '0' || this.selectedState === null || this.selectedState === '') {
            this.ErrorMessages.push('State is required.')
            this.hasError = true
        }
        if (this.zipCode === undefined || this.zipCode === 0) {
            this.ErrorMessages.push('Zip Code is required.')
            this.hasError = true
        }
        else {
            if (this.zipCode !== undefined && this.zipCode !== 0 && this.zipCode !== null) {
                let checkZipCode = this.zipCode.toString(),
                    regexVal = new RegExp('[0-9]{5}')
                let isZipCodeValid = regexVal.test(checkZipCode)
                if (!isZipCodeValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Zip Code is invalid')
                }
                else {
                    if (this.hasError === false) {
                        this._networkStateGateway.getStateCodeByZipCode(this.zipCode.toString())
                            .subscribe(
                                (data: ValidatedSelectOptionModel[]) => {
                                    if (data === null || data === undefined || data.length === 0) {
                                        this.hasError = true
                                        this.ErrorMessages.push('Zip Code is invalid')
                                    }
                                    else {
                                        let stateDetail = this.states.filter(state => state.value == this.selectedState)[0];
                                        let selState = data.filter(state => state.text.trim() == stateDetail.text.trim())
                                        if (selState === null || selState === undefined || selState.length === 0) {
                                            this.hasError = true
                                            this.ErrorMessages.push('Zip Code entered is invalid does not fall in ' + stateDetail.text)
                                        } else {
                                            this._networkStateGateway.getRegionCodeByState(this.selectedState).subscribe(
                                                (model: number) => {
                                                    this.regioncode = model

                                                    var link = this.DrugPricingToolUrl.replace(/~/g, '/').split('|').join('&') + this.regioncode
                                                    var newlink = link + '&zipcode=' + this.zipCode
                                                    window.open(newlink, '_self')
                                                }
                                            )

                                        }
                                    }
                                })
                    }
                }
            }
        }
        //else {
        //    if (this.hasError === false) {
        //        var link = this.DrugPricingToolUrl.replace(/~/g, '/').split('|').join('&') + this.selectedState
        //        var newlink = link + '&zipcode=' + this.zipCode
        //        window.open(newlink, '_self')
        //    }
        //}
    }
}
